<div class="age-gate-modal">
  <div class="age-gate-modal__backdrop"></div>
  <div class="age-gate-modal-container">
    <div class="age-gate-modal-container__content">
      <div class="age-gate-modal-container__content-title">{{modal.title}}</div>
      <div class="age-gate-modal-container__content-text">{{modal.text}}</div>
    </div>
    <div class="age-gate-modal-container__footer" *ngIf="modal.showButtons">
      <button class="age-gate-modal-container__footer-button" (click)="blockModal()">No</button>
      <button class="age-gate-modal-container__footer-button" (click)="closeModal()">Yes, I’m 21+</button>
    </div>
  </div>
</div>
